import React from 'react'
import './index.css'
import { Spin } from 'antd'
interface IProps {
  text?: string
}
const LoaderComponent = ({ text }: IProps) => {
  return (
    <div id="contenedor">
      <Spin size='large' tip={text} />
    </div>

  )
}

export default LoaderComponent
